// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__2qJiA","info":"PatientInfo_info__3MOdD"};